import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap importálása
import './Filter.css'; // Stílus hozzáadás

const apiUrl = process.env.REACT_APP_API_URL;

const Filter = ({ onFilter }) => {
  const [name, setName] = useState('');
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoryOperator, setCategoryOperator] = useState('none'); // Default operator
  const [uploadDateStart, setUploadDateStart] = useState('');
  const [uploadDateEnd, setUploadDateEnd] = useState('');
  const [creationDateStart, setCreationDateStart] = useState('');
  const [creationDateEnd, setCreationDateEnd] = useState('');
  const [categories, setCategories] = useState([]);
  const [token] = useState(localStorage.getItem('token') || '');
  const [isFilterChanged, setIsFilterChanged] = useState(false);

  // Initial state for comparison

  useEffect(() => {
    fetch(`${apiUrl}/categories`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => setCategories(data));
  }, [token]);

  const initialFilterState = useRef({
    name: '',
    selectedCategories: [],
    categoryOperator: 'none',
    uploadDateStart: '',
    uploadDateEnd: '',
    creationDateStart: '',
    creationDateEnd: [],
  });

  useEffect(() => {
    const currentFilterState = {
      name,
      selectedCategories,
      categoryOperator,
      uploadDateStart,
      uploadDateEnd,
      creationDateStart,
      creationDateEnd,
    };

    const changed = Object.keys(currentFilterState).some(
      (key) => currentFilterState[key] !== initialFilterState.current[key]
    );

    setIsFilterChanged(changed);

  }, [name, selectedCategories, categoryOperator, uploadDateStart, uploadDateEnd, creationDateStart, creationDateEnd]);

  const handleClear = () => {
    setName('');
    setSelectedCategories([]);
    setCategoryOperator('none');
    setUploadDateStart('');
    setUploadDateEnd('');
    setCreationDateStart('');
    setCreationDateEnd('');
    setIsFilterChanged(true); // maradjon piros, mert újra keresni kell
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const filterData = {
      name,
      uploadDateStart,
      uploadDateEnd,
      creationDateStart,
      creationDateEnd,
    };

    if (categoryOperator !== 'none') {
      filterData.category = selectedCategories;
      filterData.categoryOperator = categoryOperator;
    } else {
      filterData.category = null;
      filterData.categoryOperator = null;
    }

    onFilter(filterData);
    setIsFilterChanged(false);
    initialFilterState.current = {
      name,
      selectedCategories,
      categoryOperator,
      uploadDateStart,
      uploadDateEnd,
      creationDateStart,
      creationDateEnd,
    }; // új bázisállapot
  };

  const handleCategoryChange = (e) => {
    const { value, checked } = e.target;
    const categoryId = parseInt(value, 10); // Ensure categoryId is a number
    setSelectedCategories((prevSelectedCategories) =>
      checked
        ? [...prevSelectedCategories, categoryId]
        : prevSelectedCategories.filter((category) => category !== categoryId)
    );
  };

  const sorted = [...categories].sort((a, b) => a.name.localeCompare(b.name));

  const parentCategories = sorted.filter(c => c.is_parent);
  const childCategories = sorted.filter(c => !c.is_parent);

  const submitButtonClass = `btn me-2 ${isFilterChanged ? 'btn-danger' : 'btn-success'}`;

  return (
    <form onSubmit={handleSubmit} className="row g-3">
      {/* First Column: Name and Category */}
      <div className="col-md-4">
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Név:
          </label>
          <input
            type="text"
            id="name"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Keresés név szerint"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="categoryOperator" className="form-label">
            Kategória Operátor:
          </label>
          <select
            id="categoryOperator"
            className="form-select"
            value={categoryOperator}
            onChange={(e) => {
              setCategoryOperator(e.target.value);
              if (e.target.value === 'none') {
                setSelectedCategories([]); // Clear selected categories if 'none' is chosen
              }
            }}
          >
            <option value="none">Nincs kiválasztva</option>
            <option value="contains">Tartalmazza</option>
            <option value="equal">Egyenlő</option>
            <option value="not_in">Nem tartalmazza</option>
          </select>
        </div>
        {categoryOperator !== 'none' && (
          <div className="mb-3">
            <label className="form-label">
              Kategória:
            </label>
            <div className="category-checkbox-group">

              {/* Szülők */}
              {parentCategories.map(category => (
                <div key={category.id} className="form-check parent-category">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`category-${category.id}`}
                    value={category.id}
                    checked={selectedCategories.includes(category.id)}
                    onChange={handleCategoryChange}
                  />
                  <label className="form-check-label" htmlFor={`category-${category.id}`}>
                    {category.name}
                  </label>
                </div>
              ))}

              {/* Gyerekek — beljebb tolva */}
              {childCategories.map(category => (
                <div key={category.id} className="form-check child-category" >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`category-${category.id}`}
                    value={category.id}
                    checked={selectedCategories.includes(category.id)}
                    onChange={handleCategoryChange}
                  />
                  <label className="form-check-label" htmlFor={`category-${category.id}`}>
                    {category.name}
                  </label>
                </div>
              ))}

            </div>

          </div>
        )}
      </div>

      {/* Second Column: Upload Date From and To */}
      <div className="col-md-4">
        <div className="mb-3">
          <label htmlFor="uploadDateStart" className="form-label">
            Feltöltés Dátuma (mettől):
          </label>
          <input
            type="date"
            id="uploadDateStart"
            className="form-control"
            value={uploadDateStart}
            onChange={(e) => setUploadDateStart(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="uploadDateEnd" className="form-label">
            Feltöltés Dátuma (meddig):
          </label>
          <input
            type="date"
            id="uploadDateEnd"
            className="form-control"
            value={uploadDateEnd}
            onChange={(e) => setUploadDateEnd(e.target.value)}
          />
        </div>
      </div>

      {/* Third Column: Creation Date From and To */}
      <div className="col-md-4">
        <div className="mb-3">
          <label htmlFor="creationDateStart" className="form-label">
            Képkészítés Dátuma (mettől):
          </label>
          <input
            type="date"
            id="creationDateStart"
            className="form-control"
            value={creationDateStart}
            onChange={(e) => setCreationDateStart(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="creationDateEnd" className="form-label">
            Képkészítés Dátuma (meddig):
          </label>
          <input
            type="date"
            id="creationDateEnd"
            className="form-control"
            value={creationDateEnd}
            onChange={(e) => setCreationDateEnd(e.target.value)}
          />
        </div>
      </div>

      <div className="col-md-12">
        <button type="submit" className={submitButtonClass}>
          Szűrés
        </button>
        <button type="button" className="btn btn-secondary" onClick={handleClear}>
          Törlés
        </button>
      </div>
    </form>
  );
};

export default Filter;
